import {locale} from './locale.js';
import Vue from 'vue'
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

const lang = (locale[Vue.$cookies.get('language')] && Vue.$cookies.get('language')) || 'ru-ru';
const text = locale[lang];

export const steps = [
    {
        id : 'calculation_mode',
        title: text.stepInfo.calculation_mode.title,
        active : true,
        description : ''
    },

    {
        id : 1,
        title: text.stepInfo.chute_total_length_and_deain_height.title,
        active : false,
        description : text.stepInfo.chute_total_length_and_deain_height.description
    },

    {
        id: 'product_list',
        title : text.stepInfo.product_list.title,
        sub_title : text.stepInfo.product_list.sub_title,
        active : false,
        description : text.stepInfo.product_list.description
    }
];

export const criteria = [

    {
        id : 1,
        name : 'chute_total_length',
        inputType : 'text',
        image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/drain/chute_total_length.gif',
        stepId : 1,
        placeholder: text.criteriaValues.chute_total_length_placeholder,
        postfix: 'м',
        title: text.criteriaValues.chute_total_length_title,

    },
    {
        id : 2,
        name : 'drain_height',
        toggleChilds : true,
        inputType : 'text',
        image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/drain/drain_height.gif',
        stepId : 1,
        placeholder: text.criteriaValues.drain_height_placeholder,
        postfix: 'м',
        title: text.criteriaValues.drain_height_title,

    },
    {
        id : 3,
        name : 'drain_height_2',
        criterionGroup : 'drain_height',
        inputType : 'text',
        image: '',
        stepId : 1,
        placeholder: text.criteriaValues.drain_height_placeholder,
        postfix: 'м',
        title: '',
    },
    {
        id : 4,
        name : 'drain_height_3',
        criterionGroup : 'drain_height',
        inputType : 'text',
        image: '',
        stepId : 1,
        placeholder: text.criteriaValues.drain_height_placeholder,
        postfix: 'м',
        title: '',
    },

    {
        id : 5,
        name : 'drain_height_4',
        criterionGroup : 'drain_height',
        inputType : 'text',
        image: '',
        stepId : 1,
        placeholder: text.criteriaValues.drain_height_placeholder,
        postfix: 'м',
        title: '',
    },
    {
        id : 6,
        name : 'drain_height_5',
        criterionGroup : 'drain_height',
        inputType : 'text',
        image: '',
        stepId : 1,
        placeholder: text.criteriaValues.drain_height_placeholder,
        postfix: 'м',
        title: '',

    },


];